import { Button, Col, Divider, notification, Popconfirm, Row } from 'antd';
import { plantApi } from 'api/plantApi';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { selectUserInfo } from 'components/Layout/homeSlice';
import { selectIsDisable } from 'features/Login/authSlice';
import { plantActions, selectPlantInfo } from 'features/Plant/plantSlice';
import moment from 'moment';
import * as React from 'react';
import { FiChevronLeft, FiEdit } from 'react-icons/fi';
import AddEditFormPlant from '../Modal/AddEditFormPlant';
import { sidebarActions } from '../Sidebar/sidebarSlice';
import style from './PlantInfo.module.scss';
export interface PlantInfoProps {
  isShowPlantDetail: boolean;
  setIsShowPlantDetail: (value: boolean) => void;
}

export default function PlantInfo({ isShowPlantDetail, setIsShowPlantDetail }: PlantInfoProps) {
  const dispatch = useAppDispatch();
  const itemPlant = useAppSelector(selectPlantInfo);
  const [isModalVisible, setIsModalVisible] = React.useState<boolean>(false);
  // const [isEvent, setIsEvent] = React.useState<boolean>(true);
  const isEvent: boolean = true;
  const isDisable = useAppSelector(selectIsDisable);

  const userInfo = useAppSelector(selectUserInfo);
  const [userId, setUserId] = React.useState<string>('');

  React.useEffect(() => {
    if (userInfo !== undefined) {
      setUserId(userInfo.id);
    }
  }, [userInfo, dispatch]);

  const openNotificationWithIcon = (type: string, message: string) => {
    if (type === 'success' || type === 'error') notification[type]({ message: message });
    return;
  };

  const onDeleteItemPlant = async (value: string) => {
    try {
      await plantApi.remove(value);
      await dispatch(
        plantActions.fetchPlantList({ id: userId, text: null, page_size: 10, page: 0 })
      );
      await dispatch(sidebarActions.fetchSidebarList(userId));
      setIsShowPlantDetail(!isShowPlantDetail);
      openNotificationWithIcon('success', 'Delete plant successfully');
    } catch (error) {
      openNotificationWithIcon('error', 'Delete plant failed!');
    }
  };

  return itemPlant ? (
    <Row className={style.root}>
      <Row className={style.header_info}>
        <Col lg={16} xl={19} className={style.header_label_info}>
          {!isShowPlantDetail && (
            <FiChevronLeft
              style={{ marginRight: '5px', cursor: 'pointer' }}
              onClick={() => setIsShowPlantDetail(!isShowPlantDetail)}
            />
          )}
          {itemPlant?.label}
        </Col>
        <Col lg={8} xl={5} className={style.header_group_btn}>
          {!isShowPlantDetail ? (
            <Popconfirm
              placement="bottomLeft"
              title="Sure to delete?"
              onConfirm={() => onDeleteItemPlant(itemPlant.id)}
            >
              <Button disabled={isDisable} className={style.btn_delete}>
                Delete
              </Button>
            </Popconfirm>
          ) : (
            <div></div>
          )}

          <Button
            className={style.btn_edit}
            onClick={() => {
              setIsModalVisible(!isModalVisible);
            }}
          >
            Edit
            <FiEdit style={{ marginLeft: '10px' }} />
          </Button>
        </Col>
      </Row>
      <div className={style.main_detail}>
        <Divider orientation="left" plain style={{ fontWeight: 'bold' }}>
          information
        </Divider>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Code
          </Col>
          <Col span={19} className={style.values_plant_information}>
            {itemPlant?.code}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Name
          </Col>
          <Col span={19} className={style.values_plant_information}>
            {itemPlant?.label}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            System Size
          </Col>
          <Col span={19} className={style.values_plant_information}>
            {itemPlant?.system_size === null ? 'N/A' : `${itemPlant?.system_size} kWp`}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Install Date
          </Col>
          <Col span={19} className={style.values_plant_information}>
            {moment(itemPlant?.installation_date).format('DD-MM-YYYY THH:mm:ss')}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Azimuth
          </Col>
          <Col span={19} className={style.values_plant_information}>
            {itemPlant?.azimuth ? `${itemPlant?.azimuth} Degrees` : 'N/A'}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Tilt
          </Col>
          <Col span={19} className={style.values_plant_information}>
            {itemPlant?.tilt ? `${itemPlant?.tilt} Degrees` : 'N/A'}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Address
          </Col>
          <Col span={19} className={style.values_plant_information}>
            {itemPlant?.address}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Coordinates
          </Col>
          <Col span={19} className={style.values_plant_information}>
            <Col span={12} className={style.latitude}>
              Latitude: {itemPlant?.coordinantes ? `${itemPlant?.coordinantes.lat}` : `N/A`}
            </Col>
            <Col span={12} className={style.longitude}>
              Longitude: {itemPlant?.coordinantes ? `${itemPlant?.coordinantes.long}` : `N/A`}
            </Col>
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col span={5} className={style.text_plant_information}>
            Elevation
          </Col>
          <Col span={19} className={style.values_plant_information}>
            {itemPlant?.elevation ? `${itemPlant?.elevation} m` : 'N/A'}
          </Col>
        </div>
      </div>
      {/* <Row className={style.footer_list}>
        {!isShowPlantDetail && (
          <div
            className={style.btn_back_list}
            onClick={() => setIsShowPlantDetail(!isShowPlantDetail)}
          >
            <FiChevronLeft style={{ marginRight: '5px' }} /> Back
          </div>
        )}
      </Row> */}
      <AddEditFormPlant
        isEvent={isEvent}
        itemPlant={itemPlant}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      />
    </Row>
  ) : null;
}
